

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModifyMobileDrawer extends Vue{
  // private visible: boolean = false
  @Prop() private name!: string
  @Prop() private visible!: boolean
  private onClose() {
    // this.visible = false
    this.$emit('update:visible', false)
  }
}
